import { RouterAction } from "connected-react-router"
import { Reducer, Action } from "redux"
import { MarketplaceAppType } from "../../../Actions/Types"
import { APIAppInstanceModel } from "../../../Models/API/AppInstanceModel"
import { APIAppTemplateModel } from "../../../Models/API/AppTemplateModel"

export interface MarketplaceAppState {
    apps: { [appId: string]: APIAppInstanceModel }
    templates: { [templateName: string]: APIAppTemplateModel }
}

interface MarketplaceAppSetAction extends Action<MarketplaceAppType.setApp> {
    payload: APIAppInstanceModel
}

interface MarketplaceTemplateSetAction
    extends Action<MarketplaceAppType.setTemplate> {
    payload: APIAppTemplateModel
}

export type MarketplaceAppAction =
    | MarketplaceAppSetAction
    | MarketplaceTemplateSetAction

const initialState: MarketplaceAppState = {
    apps: {},
    templates: {}
}

export const MarketplaceAppReducer: Reducer<
    MarketplaceAppState,
    MarketplaceAppAction | RouterAction
> = (state = initialState, action): MarketplaceAppState => {
    switch (action.type) {
        case MarketplaceAppType.setApp:
            return {
                ...state,
                apps: { ...state.apps, [action.payload.uuid]: action.payload }
            }
        case MarketplaceAppType.setTemplate:
            return {
                ...state,
                templates: {
                    ...state.templates,
                    [action.payload.name]: action.payload
                }
            }

        default:
            return state
    }
}
